module.exports = __webpack_public_path__ + "static/media/YDSM2.cfd184e3.pdf";